import { IVincularAtendimento } from "../../../../Interfaces/AssistenciaTecnica/Atendimento/AtendimentoVinculado/AtendimentoVinculadoInterfaces";
import {
    AbrirAtendimentoVinculadoService,
    ListarAtendimentosVinculadosService,
} from "../../../../Services/AssistenciaTecnica/Atendimento/AtendimentoVinculado/AtendimentoVinculadoService";
import { Controller } from "../../../Controller";

export function ListarAtendimentosVinculadosController(idCaso: number) {
    return Controller(ListarAtendimentosVinculadosService(idCaso));
}

export function AbrirAtendimentoVinculadoController(
    abriratendimentovinculado: IVincularAtendimento
) {
    return Controller(
        AbrirAtendimentoVinculadoService(abriratendimentovinculado)
    );
}
